export const boxShadow = {
  main: `0 0.0625rem 0.375rem 0 rgb(0 0 0 / 15%)`,
  tooltip: `0px 3px 4px 0px rgba(0,0,0,0.26)`,
  dark: `0 3px 4px rgba(0, 0, 0, 0.7)`
};
